(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.ZonesDialogHandler = (function(superClass) {
    extend(ZonesDialogHandler, superClass);

    function ZonesDialogHandler() {
      return ZonesDialogHandler.__super__.constructor.apply(this, arguments);
    }

    ZonesDialogHandler.prototype.init = function() {
      this.ppID = parseInt($(this.parent.layoutSelector).find('#sel_sz_pp').val());
      this.layoutUrl = 'backend/portal/zones/zones/load-layout';
      if (this.loadLayoutPostOptions == null) {
        this.loadLayoutPostOptions = {};
      }
      this.loadLayoutPostOptions.pp_id = this.ppID;
      this.subHandlers = {
        'AddEdit': {
          'class': 'portal::handlers/zones/AddEditDialog'
        },
        'AddEditWithIrr': {
          'class': 'portal::handlers/zones/AddEditDialogWithIrr'
        },
        'AddEditWithGrower': {
          'class': 'portal::handlers/zones/AddEditDialogWithGrower'
        },
        'ZoneDelete': {
          'class': 'portal::handlers/zones/ZonesDeleteDialogHandler'
        }
      };
      return this.createDialog();
    };

    ZonesDialogHandler.prototype.afterLoadLayout = function(selector, response) {
      var ref, ref1, self, size;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      self = this;
      switch ((ref1 = response.data) != null ? ref1.add_edit_handler : void 0) {
        case 'with_grower':
          this.addEditHandler = 'AddEditWithGrower';
          break;
        case 'with_irr':
          this.addEditHandler = 'AddEditWithIrr';
          break;
        default:
          this.addEditHandler = 'AddEdit';
      }
      this.dialog.find('.zones-container').on('click', '.btn-zone-edit', null, function() {
        var btn, id;
        btn = $(this);
        id = btn.data('zone-id');
        return self.addEditZone(id);
      });
      this.dialog.find('.zones-container').on('click', '.btn-zone-delete', null, function() {
        var id;
        id = $(this).data('zone-id');
        return self.deleteZone(id);
      });
      size = this.dialog.find('.modal-body').height() - 35;
      this.table = this.dialog.find('.table').dataTable({
        'sScrollY': size + 'px',
        'bPaginate': false,
        'bFilter': false,
        'bInfo': false,
        'bSort': false,
        'aaSorting': []
      });
      return $(window).unbind('modal_resized').bind('modal_resized', debounce((function(_this) {
        return function(e) {
          var ref2;
          if (((ref2 = _this.table) != null ? ref2.fnSettings() : void 0) != null) {
            size = _this.dialog.find('.modal-body').height() - 35;
            _this.table.fnSettings().sY = size + "px";
            _this.dialog.find('.dataTables_scrollBody').height(size);
            return _this.table.fnAdjustColumnSizing();
          }
        };
      })(this)));
    };

    ZonesDialogHandler.prototype.addEditZone = function(id) {
      var handler;
      if (id == null) {
        id = null;
      }
      handler = this.createSubHandler(this.addEditHandler);
      if (handler) {
        if (id != null) {
          handler.loadLayoutPostOptions = {
            sz_id: id
          };
        }
        return handler.init();
      }
    };

    ZonesDialogHandler.prototype.deleteZone = function(id) {
      var handler;
      handler = this.createSubHandler('ZoneDelete');
      if (handler) {
        handler.loadLayoutPostOptions = {
          sz_id: id
        };
        return handler.init();
      }
    };

    return ZonesDialogHandler;

  })(FullPageHandler);

}).call(this);
